import { createFileRoute } from "@tanstack/react-router";

import { DocumentTitle } from "@/components";
import { EditBankAccountPage } from "@/modules/settings/pages/edit-bank-account-page";
import { requireAuth } from "@/utils";

export const Route = createFileRoute("/settings/bank-information/$bankInfoId")({
  beforeLoad: requireAuth,
  component: () => (
    <>
      <DocumentTitle
        title="Edit Bank Account"
        description="Edit your bank account information for receiving payments."
      />
      <EditBankAccountPage />;
    </>
  )
});
